import { z } from 'zod'

export const ERROR_CODES = [
  'VALIDATION_FAILED',
  'UNAUTHENTICATED',
  'FORBIDDEN',
  'NOT_FOUND',
  'CONFLICT',
  'CLAIM_REQUIRED',
  'CLAIM_HELD_BY_OTHER',
  'IDEMPOTENCY_REPLAY_MISMATCH',
  'REPLY_IN_PROGRESS',
  'ALREADY_ANSWERED',
  'REPLY_WINDOW_CLOSED',
  'UPSTREAM_REJECTED',
  'UPSTREAM_UNAVAILABLE',
  'BUDGET_EXHAUSTED',
  'AI_CREDENTIALS_MISSING',
  'RATE_LIMITED',
  'PASSWORD_CHANGE_REQUIRED',
  'PASSWORD_NOT_SETTABLE',
  'MULTI_TENANT_DISABLED',
  'META_APP_REQUIRED',
  'META_APP_CHANGE_DISCONNECTS',
  'META_APP_UNREADABLE',
  'INTERNAL',
] as const

export const ErrorCode = z.enum(ERROR_CODES)
export type ErrorCode = z.infer<typeof ErrorCode>

export const ERROR_HTTP_STATUS: Record<ErrorCode, number> = {
  VALIDATION_FAILED: 400,
  UNAUTHENTICATED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  CONFLICT: 409,
  CLAIM_REQUIRED: 409,
  CLAIM_HELD_BY_OTHER: 409,
  IDEMPOTENCY_REPLAY_MISMATCH: 422,
  REPLY_IN_PROGRESS: 409,
  ALREADY_ANSWERED: 409,
  REPLY_WINDOW_CLOSED: 409,
  UPSTREAM_REJECTED: 422,
  UPSTREAM_UNAVAILABLE: 503,
  BUDGET_EXHAUSTED: 429,
  AI_CREDENTIALS_MISSING: 409,
  RATE_LIMITED: 429,
  PASSWORD_CHANGE_REQUIRED: 403,
  PASSWORD_NOT_SETTABLE: 409,
  MULTI_TENANT_DISABLED: 409,
  META_APP_REQUIRED: 409,
  META_APP_CHANGE_DISCONNECTS: 409,
  META_APP_UNREADABLE: 409,
  INTERNAL: 500,
}

export const ERROR_MESSAGES: Record<ErrorCode, string> = {
  VALIDATION_FAILED: '輸入資料格式不正確',
  UNAUTHENTICATED: '請重新登入',
  FORBIDDEN: '你沒有執行這個操作的權限',
  NOT_FOUND: '找不到指定的資料',
  CONFLICT: '資料已被其他人更新，請重新整理後再試',
  CLAIM_REQUIRED: '請先認領這個項目再回覆',
  CLAIM_HELD_BY_OTHER: '這個項目正由其他人處理',
  IDEMPOTENCY_REPLAY_MISMATCH: '重複送出的內容與先前不一致',
  REPLY_IN_PROGRESS: '另一則回覆正在送出給這位客人，你的回覆沒有送出',
  ALREADY_ANSWERED: '這則客人訊息已經有人回覆了，你的回覆沒有送出',
  REPLY_WINDOW_CLOSED:
    '已超過 Meta 規定的 24 小時私訊回覆期限，你的回覆沒有送出。要等客人再傳訊息才可以再回覆；在那之前請改用電話或其他方式聯絡客人。',
  UPSTREAM_REJECTED: '外部服務拒絕了這個操作',
  UPSTREAM_UNAVAILABLE: '外部服務暫時無法使用，請稍後再試',
  BUDGET_EXHAUSTED: '本月 AI 用量已達上限',
  AI_CREDENTIALS_MISSING: '尚未設定 AI 供應商金鑰，請管理員到「設定 → AI 供應商」填入後再試',
  RATE_LIMITED: '嘗試次數過多，請稍後再試',
  PASSWORD_CHANGE_REQUIRED: '請先更改管理員替你設定的臨時密碼，才可以繼續使用。',
  PASSWORD_NOT_SETTABLE: '不能替這個帳號設定密碼',
  MULTI_TENANT_DISABLED: '目前每個帳號只可以屬於一個工作區，平台也只可以有一個工作區。',
  META_APP_REQUIRED: '請先設定 Meta 應用程式，才能連接粉專',
  META_APP_CHANGE_DISCONNECTS: '更換應用程式會中斷已連接的粉專，需要重新連接',
  META_APP_UNREADABLE: '已儲存的 Meta 應用程式設定無法讀取，請重新輸入 App ID 與 App Secret 儲存一次',
  INTERNAL: '系統發生錯誤，請稍後再試',
}
